import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { makeDefaultPreviewCard } from '../store/resources';


export default function PreviewCard(props) {
  const dispatch = useDispatch();
  const domain = useSelector(state => state.app.current_domain);

  const setDefault = (e) => {
    e.preventDefault();
    dispatch(makeDefaultPreviewCard(domain, props.preview_card.id));
  };

  return (
    <tr className="align-middle">
        <td>{ props.preview_card.is_default ? "*" : (
            <a href="/make_default" onClick={setDefault}>Make default</a>
        ) }</td>
        <td><img alt={props.preview_card.name} height="30" src={ props.preview_card.image_url }/></td>
        <td>{ props.preview_card.name }</td>
        <td>{ props.preview_card.title }</td>
        <td>{ props.preview_card.description }</td>
        <td><Link to={"/preview_card/" + props.preview_card.id}>Edit</Link></td>
    </tr>
  );
}
